( function( app ) {
  const COMPONENT = {
    init: function() {
      // Only open nav panels on hover for desktop widths with a mouse, mobile/touch opens on click
      const canHover = function() {
        return $( window ).width() > 1024 && window.matchMedia( '(hover: hover) and (pointer: fine)' ).matches;
      };

      $( '.navigation-five .primary-menu-item' ).has( '.primary-menu-item__menu' )
          .on( 'mouseenter', function() {
            if ( !canHover() ) return;
            const $trigger = $( this ).find( '.primary-menu-item__link' );
            if ( !$trigger.hasClass( 'is-open' ) ) {
              $trigger.trigger( 'click' );
            }
          } )
          .on( 'mouseleave', function() {
            if ( !canHover() ) return;
            const $trigger = $( this ).find( '.primary-menu-item__link' );
            if ( $trigger.hasClass( 'is-open' ) ) {
              // easy-toggle-state focuses the trigger on close, so drop it unless it already had focus
              const hadFocus = $trigger.is( ':focus' );
              $trigger.trigger( 'click' );
              if ( !hadFocus ) {
                $trigger.trigger( 'blur' );
              }
            }
          } );

      // Ignore mouse clicks on a menu item that hover already opened so it doesn't toggle closed.
      // Runs in the capture phase so easy-toggle-state never sees the click. Keyboard and triggered clicks have a detail of 0 and pass through
      const primaryNav = document.getElementById( 'primary-nav' );
      if ( primaryNav ) {
        primaryNav.addEventListener( 'click', function( e ) {
          const trigger = e.target.closest( '.primary-menu-item__link[data-toggle-target]' );
          if ( trigger && trigger.classList.contains( 'is-open' ) && e.detail > 0 && canHover() ) {
            e.stopPropagation();
            e.preventDefault();
          }
        }, true );
      }

      // Center compact panels under the open menu item and position the caret
      $( '.navigation-five .primary-menu-item__link[data-toggle-target]' ).on( 'toggleAfter', function() {
        if ( $( window ).width() <= 1024 ) return;
        const $panel = $( $( this ).data( 'toggle-target' ) );
        const triggerCenter = $( this ).offset().left + ( $( this ).outerWidth() / 2 );

        if ( $panel.hasClass( 'primary-menu-item__menu--compact' ) ) {
          const $container = $panel.offsetParent();
          const gutter = 24;
          const maxLeft = $container.outerWidth() - $panel.outerWidth() - gutter;
          const panelLeft = Math.max( gutter, Math.min( maxLeft, triggerCenter - $container.offset().left - ( $panel.outerWidth() / 2 ) ) );
          $panel[0].style.setProperty( '--panelLeft', `${panelLeft}px` );
        }

        const caretLeft = triggerCenter - $panel.offset().left;
        $panel[0].style.setProperty( '--caretLeft', `${caretLeft}px` );
      } );

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-five .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-five', COMPONENT );
} )( app );
